"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createTranslation = void 0;
/**
 * Creates a `translation` entry
 *
 * @param {object} entry.fields
 * @param {string} entry.fields.key - The translation key
 * @param {string} entry.fields.phrase - The translation key content
 * @returns {array<string>} - An array for the translation with the shape [key, phrase]
 */
var createTranslation = function createTranslation(_ref) {
  var fields = _ref.fields;
  return [fields.key, fields.phrase];
};

/**
 * Creates a map of translation keys mapped to their phrases
 *
 * @param {array<object>} items - An array of contentful entries
 * @returns {object} - A translations hashmap
 */
exports.createTranslation = createTranslation;
var translationsFactory = function translationsFactory(items) {
  return Object.fromEntries(items.map(createTranslation));
};
var _default = translationsFactory;
exports["default"] = _default;